import type { SchemaData } from '../schema/types'
import { autoLineDiagram } from './autoLineDiagram'
import type { LineDiagramSpec } from './LineDiagram'

/**
 * The rail diagram the line view draws for `lineId`: the city's hand-written
 * table when it has one, else the automatic straight-line diagram, else
 * `null` — no line view for that line in this city.
 */
export function lineDiagramFor(
  schema: SchemaData,
  lineId: string,
  tables: Readonly<Record<string, LineDiagramSpec>>,
): LineDiagramSpec | null {
  return tables[lineId] ?? autoLineDiagram(schema, lineId)
}
